@import '~@union-investment/global-resources/src/styles/solid-design-system';

:host {
  container-type: inline-size;
  width: 100%;
  display: block;

  .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .image {
    width: 100%;

    img {
      display: block;
      width: 100%;
    }
  }

  .description {
    width: 100%;
    font-style: normal;

    sd-link {
      display: block;
      margin: 0 0 $sd-spacing-2;
    }

    p {
      margin: 0;
    }

    .name {
      margin-bottom: $sd-spacing-2;
    }

    .details {
      margin-bottom: $sd-spacing-4;
    }

    .address {
      margin-bottom: $sd-spacing-4;

      sd-link {
        margin-bottom: 0;

        &:last-child {
          margin-top: $sd-spacing-4;
        }

        &:first-child {
          margin-top: 0;
        }
      }
    }

    .contacts {
      margin-bottom: $sd-spacing-4;
    }

    .social-links {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: $sd-spacing-4;

      sd-link {
        margin-bottom: 0;

        &:first-child {
          margin-right: $sd-spacing-8;
        }
      }
    }
  }

  @container (min-width: 500px) {
    .content-wrapper {
      flex-direction: row;
    }
  }
}
